"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBudgetQuestion = void 0;
var _reactRedux = require("react-redux");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _utils = require("../../utils/utils");
var _services = require("../../services");
var _react = require("react");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _useUserSessionStatus2 = require("../user/useUserSessionStatus");
var _useQuestionnaireNavigation = require("./useQuestionnaireNavigation");
var _lodash = _interopRequireDefault(require("lodash.isempty"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useBudgetQuestion = function useBudgetQuestion(question) {
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useQuestionnaireNavi = (0, _useQuestionnaireNavigation.useQuestionnaireNavigation)(),
    onSkip = _useQuestionnaireNavi.onSkip;
  var budget = (0, _reactRedux.useSelector)(_questionnaireSelectors.selectBudget);
  var budgetQuestion = (0, _utils.clone)(question);
  var minValue = budget.minValue,
    minPlanValueAdjusted = budget.minPlanValueAdjusted,
    minHandsetValueAdjusted = budget.minHandsetValueAdjusted,
    recommendedPlanPrice = budget.recommendedPlanPrice,
    recommendedHandsetPrice = budget.recommendedHandsetPrice,
    maxValue = budget.maxValue,
    maxPlanValueAdjusted = budget.maxPlanValueAdjusted,
    maxHandsetValueAdjusted = budget.maxHandsetValueAdjusted,
    lastSelectedBudget = budget.lastSelectedBudget;
  var isBudgetReady = !(0, _lodash.default)(budget);
  var shouldSkipQuestion = isBudgetReady && minValue === maxValue;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    isRecommendedValueAssigned = _useState2[0],
    setIsRecommendedValueAssigned = _useState2[1];
  var _useUserSessionStatus = (0, _useUserSessionStatus2.useUserSessionStatus)(),
    isSavingUserSession = _useUserSessionStatus.isSavingUserSession;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    shouldFetchBudget = _useState4[0],
    setShouldFetchBudget = _useState4[1];
  var defaultSelection = budgetQuestion.type === _constants.QUESTION_TYPE.MULTI ? budgetQuestion.multi.length > 1 ? budgetQuestion.multi[0].rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice, recommendedPlanPrice] : [recommendedPlanPrice, recommendedHandsetPrice] : budgetQuestion.multi[0].rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice] : [recommendedPlanPrice] : budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? [recommendedHandsetPrice] : [recommendedPlanPrice];
  (0, _react.useEffect)(function () {
    if (!isSavingUserSession && !shouldFetchBudget) {
      setShouldFetchBudget(true);
    }
  }, [isSavingUserSession]);
  (0, _react.useEffect)(function () {
    if (!isBudgetReady && shouldFetchBudget) {
      dispatch((0, _questionnaireActions.resetSelections)());
      dispatch((0, _questionnaireActions.fetchBudget)());
      setIsRecommendedValueAssigned(false);
    }
  }, [shouldFetchBudget]);
  (0, _react.useEffect)(function () {
    if (!isRecommendedValueAssigned && isBudgetReady) {
      defaultSelection.forEach(function (value, index) {
        dispatch((0, _questionnaireActions.replaceSelection)(value, index));
      });
      setIsRecommendedValueAssigned(true);
    }
  }, [defaultSelection]);
  (0, _react.useEffect)(function () {
    if (shouldSkipQuestion) {
      onSkip();
    }
  }, [shouldSkipQuestion]);
  var onAdjustBudget = function onAdjustBudget(selection) {
    if (selection === lastSelectedBudget) {
      dispatch((0, _questionnaireActions.adjustBudget)(false));
    } else {
      dispatch((0, _questionnaireActions.setBudget)(_objectSpread(_objectSpread({}, budget), {}, {
        lastSelectedBudget: selection
      })));
      dispatch((0, _questionnaireActions.adjustBudget)(true));
    }
  };
  if (budgetQuestion.type === _constants.QUESTION_TYPE.MULTI) {
    budgetQuestion.multi = budgetQuestion.multi.map(function (multiSegment) {
      var minValueAdjusted = multiSegment.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? minHandsetValueAdjusted : minPlanValueAdjusted;
      var maxValueAdjusted = multiSegment.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? maxHandsetValueAdjusted : maxPlanValueAdjusted;
      return _objectSpread(_objectSpread({}, multiSegment), {}, {
        id: _constants.QUESTION_ID.BUDGET,
        rangeChoices: {
          min: minValueAdjusted,
          max: maxValueAdjusted,
          shouldSkipSegment: minValueAdjusted === maxValueAdjusted,
          minLabel: _services.locale.formatPrice(minValueAdjusted, {
            fraction: false
          }),
          maxLabel: _services.locale.formatPrice(maxValueAdjusted, {
            fraction: false
          })
        }
      });
    });
  } else {
    var minValueAdjusted = budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? minHandsetValueAdjusted : minPlanValueAdjusted;
    var maxValueAdjusted = budgetQuestion.rangeCategory === _constants.PRODUCT_TYPES.HANDSET.toLowerCase() ? maxHandsetValueAdjusted : maxPlanValueAdjusted;
    budgetQuestion.rangeChoices = {
      min: minValueAdjusted,
      max: maxValueAdjusted,
      shouldSkipSegment: minValueAdjusted === maxValueAdjusted,
      minLabel: _services.locale.formatPrice(minValueAdjusted, {
        fraction: false
      }),
      maxLabel: _services.locale.formatPrice(maxValueAdjusted, {
        fraction: false
      })
    };
  }
  return {
    isBudgetReady: isBudgetReady,
    budgetQuestion: budgetQuestion,
    adjustBudget: onAdjustBudget
  };
};
exports.useBudgetQuestion = useBudgetQuestion;